import React from 'react'
import logo_default from '../assets/images/szambelan_uszczegolowienie.svg'
import SzambelanStyle from '../styles/SzambelanStyle'

const Szambelan = function({ text, logo }) {
  return (
    <SzambelanStyle>
      <img src={logo ? logo : logo_default} alt="logo" />
      <h1 className="medium-headline-4">{text ? text : 'Brak danych'}</h1>
    </SzambelanStyle>
  )
}

export default Szambelan
